<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="paginatedValues"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      :filterable="false"
      :clearable="isClearable"
      :placeholder="placeholder"
      :multiple="isMultiple"
      @search="onSearch"
      @input="onInput"
      @search:focus="onFocus"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="usersState.loading"
          :style="{ opacity: usersState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        escribe para buscar usuarios..
      </template>
      <li
        v-if="hasNextPage"
        slot="list-footer"
        class="pagination"
      >
        <button
          class="btn btn-block btn-primary btn-sm"
          type="button"
          @click="searchPage"
          :disabled="!hasNextPage"
        >
          buscar mas usuarios...
        </button>
      </li>
    </v-select>
    <div
      v-if="withFilters"
      class="d-flex mt-1"
    >
      <b-form-radio
        v-b-tooltip.hover.bottom="'Selecciona y escribe el nombre para encontrar usuarios'"
        class="mr-5"
        v-model="filterBy"
        name="label"
        value="label"
      >
        Por nombre
      </b-form-radio>
      <b-form-radio
        v-b-tooltip.hover.bottom="'Selecciona y escribe el rut para encontrar usuarios'"
        class="mr-5"
        v-model="filterBy"
        name="iut"
        value="iut"
      >
        Por rut
      </b-form-radio>
      <b-form-radio
        v-b-tooltip.hover.bottom="'Selecciona y escribe el cargo para encontrar usuarios'"
        class="mr-5"
        v-model="filterBy"
        name="position"
        value="position"
      >
        Por cargo
      </b-form-radio>
      <b-form-radio
        v-b-tooltip.hover.bottom="'Selecciona y escribe el correo para encontrar usuarios'"
        class="mr-5"
        v-model="filterBy"
        name="email"
        value="email"
      >
        Por correo
      </b-form-radio>
    </div>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;"
    >
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      limit: 10,
      page: 1,
      pages: 1,
      filterBy: 'label'
    };
  },
  computed: {
    ...mapGetters('Empresas', ['companyId', 'company']),
    ...mapGetters('Usuario', ['currentUserId']),
    usersState() {
      const indexedBy = [
        this.companyId,
        this.groupFilter,
        this.divisionFilter,
        this.rolId,
        this.onlyLeaders ? 'Y' : '',
        this.filtersUserGroup
      ].filter(Boolean).join('-') || 'value';
      const index = this.$store.state.List.users[indexedBy] || {};
      // console.log('---- indexedBy 1', indexedBy, index);
      let users = Object.values(index);

      if (this.onlyConventional) {
        users = users.filter((user) => user.position.match(/convencional/i));
      }
      if (this.onlyRol) {
        users = users.filter((user) => user.rol);
      }
      return {
        value: users.sort((a, b) => a.label.localeCompare(b.label)),
        loading: this.$store.state.List.users.loading
      };
    },
    isWizard() {
      return this.$route.name === 'files-wizard';
    },
    isDisabled() {
      return this.disabled;
    },
    optionSelected() {
      return this.usersState.value
        .find((option) => option.value === this.value);
    },
    hasNextPage() {
      return this.page < Math.max(this.pages, this.filteredPages);
    },
    filteredValues() {
      const toFilter = this.filterBy;
      const needle = this.query.toLowerCase();
      return this.usersState.value.filter((val) => {
        const field = val[toFilter];
        return typeof field === 'string' && field.toLowerCase().includes(needle);
      });
    },
    paginatedValues() {
      if (this.filterMeUser) {
        if (this.isApprovals) {
          return this.filteredValues.slice(0, this.limit * this.page);
        }
        const values = this.filteredValues.slice(0, this.limit * this.page);
        return values.filter((el) => el.id !== this.currentUserId);
      }
      return this.filteredValues.slice(0, this.limit * this.page);
    },
    filteredPages() {
      return this.filteredValues.length / this.limit;
    }
  },
  methods: {
    ...mapActions('List', ['fetchUsers']),
    usersIndexKey() {
      return [
        this.companyId,
        this.groupFilter,
        this.divisionFilter,
        this.rolId,
        this.onlyLeaders ? 'Y' : '',
        this.filtersUserGroup
      ].filter(Boolean).join('-') || 'value';
    },
    onInput(event) {
      this.$emit('full-user', event);
      this.$emit('input', event);
      this.$emit('set-position', event);
    },
    onFocus() {
      this.page = 1;
      this.query = '';
      if (!this.loading && this.usersState.value.length) return;
      this.debounceFetchUsers({});
    },
    searchPage() {
      this.debounceFetchUsers({ page: this.page += 1, query: this.query });
    },
    onSearch(query) {
      if (!query) return;
      this.pages = 1;
      this.query = query;
      this.debounceFetchUsers({ query });
    },
    debounceFetchUsers: _.debounce(async function debounceFetchUsers(payload = {}) {
      const { pages } = await this.fetchUsers({
        ...payload,
        ...(this.rolId && { rolId: this.rolId }),
        ...(this.groupFilter && { grupoId: this.groupFilter }),
        ...(this.divisionFilter && { divisionId: this.divisionFilter }),
        ...(this.onlyLeaders && { soloLideres: 'Y' }),
        ...(this.filtersUserGroup && { filtroGrupos: this.filtersUserGroup })
      });
      this.pages = pages;
    }, 350),
    getOption() {
      return this.usersState.value.filter((option) => this.value
        .find((opt) => opt.id === option.id));
    }
  },
  watch: {
    async divisionFilter(newValue, oldValue) {
      this.$emit('input', '');
      if (newValue !== oldValue) {
        if (oldValue !== '') {
          this.$emit('input', '');
        }
        this.page = 0;
        await this.searchPage(0);
      }
    },
    async groupFilter(newValue, oldValue) {
      this.$emit('input', '');
      if (newValue !== oldValue) {
        if (oldValue !== '') {
          this.$emit('input', '');
        }
        this.page = 0;
        await this.searchPage(0);
      }
    }
  },
  props: {
    name: { type: String, required: true },
    withFilters: { type: Boolean, default: false },
    rolId: { type: String },
    placeholder: String,
    label: { type: String, default: 'Usuarios' },
    value: { type: String },
    required: { type: Boolean, default: false },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    onlyConventional: { type: Boolean, default: false },
    onlyRol: { type: Boolean, default: false },
    isMultiple: { type: Boolean, default: false },
    isApprovals: { type: Boolean, default: false },
    filterMeUser: { type: Boolean, default: false },
    divisionFilter: String,
    groupFilter: String,
    onlyLeaders: { type: Boolean, default: false },
    filtersUserGroup: String
  }
};

</script>
